export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1d7623ae8e7739092ccbde4465319bc8.jpg"
          alt="Venezuela"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 md:px-6 py-32 md:py-40">
        {/* Badge */}
        <a
          href="https://remesasve.com"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-2 bg-green-500/20 border border-green-400/40 text-green-300 text-xs font-semibold uppercase tracking-widest rounded-full px-4 py-1.5 mb-6"
        >
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse inline-block"></span>
          Actualizado hoy · 1 de abril, 2026
        </a>

        <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-5 tracking-tight">
          Precio del dólar{' '}
          <span className="text-green-400">hoy</span>{' '}
          en Venezuela
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
          Consulta la tasa actual del dólar y encuentra la mejor forma de enviar dinero a Venezuela.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://remesasve.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-bold text-base rounded-full px-8 py-4 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-green-500/30 hover:scale-105 active:scale-95"
          >
            <i className="ri-send-plane-fill text-lg w-5 h-5 flex items-center justify-center"></i>
            Ver mejores opciones para enviar dinero
          </a>
          <a
            href="https://remesasve.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold text-base rounded-full px-6 py-4 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-bar-chart-line text-lg w-5 h-5 flex items-center justify-center"></i>
            Ver tasa del dólar
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 opacity-60">
          <span className="text-white text-xs tracking-widest uppercase">Explorar</span>
          <i className="ri-arrow-down-line text-white text-xl animate-bounce w-6 h-6 flex items-center justify-center"></i>
        </div>
      </div>
    </section>
  );
}
